"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = House;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function House(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "64",
    height: "60",
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group 837"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector",
    d: "M59 25.3777V58.7576H5V40.1476M12.82 58.5977V35.0377H24.82V58.5977H12.82ZM40.71 48.7276H32.71V35.5476H40.71V48.7276ZM52.83 48.7276H44.83V35.5476H52.83V48.7276ZM4 25.3477H60H4ZM5 30.1476V25.3777V30.1476Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_2",
    d: "M8.29095 38.29C8.29095 38.7221 8.20583 39.1499 8.0405 39.549C7.87516 39.9482 7.63284 40.3109 7.32733 40.6164C7.02183 40.9219 6.65914 41.1642 6.25998 41.3296C5.86082 41.4949 5.43299 41.58 5.00095 41.58C4.5689 41.58 4.14107 41.4949 3.74191 41.3296C3.34275 41.1642 2.98007 40.9219 2.67456 40.6164C2.36906 40.3109 2.12673 39.9482 1.9614 39.549C1.79606 39.1499 1.71094 38.7221 1.71094 38.29C1.71094 37.4174 2.05757 36.5806 2.67456 35.9636C3.29156 35.3466 4.12838 35 5.00095 35C5.87351 35 6.71034 35.3466 7.32733 35.9636C7.94433 36.5806 8.29095 37.4174 8.29095 38.29",
    fill: "#54C8E8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_3",
    d: "M32 1L1 25.36H63L32 1Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}